import { render, staticRenderFns } from "./ServicePricingCreateForm.vue?vue&type=template&id=21feacde"
import script from "./ServicePricingCreateForm.vue?vue&type=script&lang=js"
export * from "./ServicePricingCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports